package com.rainbowclubs.rainbow.domain.use_cases.events

import com.rainbowclubs.rainbow.data.models.Event
import com.rainbowclubs.rainbow.data.requests.CreateEventRequest
import com.rainbowclubs.rainbow.domain.repositories.EventsRepository

class CreateEventUseCase(
    private val eventsRepository: EventsRepository,
) {
    suspend operator fun invoke(request: CreateEventRequest): Result<Event> {
        return eventsRepository.createEvent(request)
    }
}
